export class GroupRoutingNames {
    public static readonly NAME_BASE = '';
    public static readonly NAME_GROUP = 'group';

    public static readonly ROUTE_BASE = `/${GroupRoutingNames.NAME_BASE}`;
    public static readonly ROUTE_GROUP = `/${GroupRoutingNames.NAME_GROUP}`;
}
